import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('navbar', '.header');
loader('videocard', '.video-card');
